import * as types from 'store/user/userTypes'
import moment from 'moment'
import bootRollbar from 'shared/helpers/rollbar'
import { fillUserTimezone } from 'shared/helpers/functional'

const initialState = {
  icUserToken: '',
  isFetching: false,
  fetched: false,
  tokenExpired: false,
  authed: false,
  userInfo: {
    timeZone: "",
  },
  selectedAccount: 1,
  showAccountTooltip: true,
  filteredClients: new Set(),
  showClientTooltip: true,
  isSubmitting: false,
  usersDetails: [],
  isLoading: false,
  isUpdating: false,
}

const toggleItemId = (filteredItemsById, id) => {
  if (filteredItemsById.has(id)) {
    filteredItemsById.delete(id)
  } else {
    return filteredItemsById.add(id)
  }

  return filteredItemsById
}

const updateUserDetails = (usersDetails, user, date) => {
  let objIndex = usersDetails.findIndex((obj => obj.cognitoUserId == user.userId))
  usersDetails[objIndex].allow_contact_by_email = user.allowContactByEmail === "0" ? false : true
  usersDetails[objIndex].byWho = user.pmName
  usersDetails[objIndex].modifiedDate = date
  return usersDetails
}

/*
  Would like to move to ramda at a later point or use in other parts of app
  however if we want proper type coverage, we need to wait for the definitions to
  be finished for the latest release of flow and/or ramda.
  In the interim, Object.assign will be fine.
*/

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_USER_REQUESTED:
    case types.PUT_USER_PASSWORD_REQUESTED:
      return { ...state, isFetching: true }
    case types.FETCH_USER_SUCCEEDED:
      // Update rollbar with loaded user
      //bootRollbar({id: action.id, email: action.payload.body.Username})
      console.log("moment.tz.guess() ", moment.tz.guess())
      return {
        ...state,
        attemptedInitialAuth: true,
        authed: true,
        isFetching: false,
        tokenExpired: false,
        selectedAccount: action.payload.accountsSelected? action.payload.accountsSelected : 1,
        filteredClients: action.payload.clientsSelected? new Set(action.payload.clientsSelected) : state.filteredClients,
        userInfo: fillUserTimezone(action.payload.time_zone),
        email: action.payload.email,
        userId:action.payload.id,
        userRole:action.payload.roles,
        userFirstName: action.payload.first_name,
        userLastName: action.payload.last_name,
      }
    case types.FETCH_USER_FAILED:
      return {
        ...state,
        attemptedInitialAuth: true,
        authed: false,
        isFetching: false,
      }
    case types.SELECT_ACCOUNT:
      return {
        ...state,
        selectedAccount: action.payload.account,
        showAccountTooltip: action.payload.hideTooltip? false : action.payload.account !== 1,
        showClientTooltip: action.payload.hideTooltip? false : state.showClientTooltip
      }
    case types.SET_SHOW_ACCOUNT_TOOLTIP:
      return {
        ...state,
        showAccountTooltip: action.payload.showAccountTooltip
      }
    case types.SELECT_CLIENT:
      let filteredClients
      if(action.payload) {
        if(!action.payload.fromLogin) {
          if(!action.payload.fromAccountUpdate){
           filteredClients = toggleItemId(state.filteredClients, action.payload)
          } else {
            filteredClients = new Set()
          }
        } else {
          filteredClients = action.payload.clients
        }
      } else {
        filteredClients = new Set()
      }
      return {
        ...state,
        filteredClients: filteredClients,
        showClientTooltip: action.payload && action.payload.fromAccountUpdate? true: false
      }
    case types.SET_SHOW_CLIENTS_TOOLTIP:
      return {
        ...state,
        showClientTooltip: action.payload.showClientTooltip
      }
    case types.PUT_USER_PASSWORD_SUCCEEDED:
    case types.PUT_USER_PASSWORD_FAILED:
      return { ...state, isFetching: false }
    case types.UPDATE_USER_TIMEZONE_SUCCEEDED:
      return { ...state, isSubmitting: false,  userInfo: {timeZone: action.timezone} }
    case types.UPDATE_USER_TIMEZONE_FAILED:
      return { ...state, isSubmitting: false}
    case types.UPDATE_USER_TIMEZONE_REQUESTED:
      return { ...state, isSubmitting: true }
    case types.FETCH_BUFFER_SUCCEEDED:
        return { ...state, isFetching: false }
    case types.PUT_PASSWORD_MATCHES_REQUESTED:
      return { ...state, isFetching: true, passwordMatches: true }
    case types.PUT_PASSWORD_MATCHES_SUCCEEDED:
      return { ...state, isFetching: false, passwordMatches: true }
    case types.PUT_PASSWORD_MATCHES_FAILED:
      return { ...state, isFetching: false, passwordMatches: false }
    case types.FETCH_ALL_USERS_DETAILS_REQUESTED:
      return { ...state, isLoading: true }
    case types.FETCH_ALL_USERS_DETAILS_SUCCEEDED:
      return { ...state, usersDetails:action.usersDetails, isLoading: false }
    case types.FETCH_ALL_USERS_DETAILS_FAILED:
      return { ...state, isLoading: false }  
    case types.UPDATE_ALLOW_CONTACT_BY_EMAIL_REQUESTED:
      return { ...state, isUpdating: true }
    case types.UPDATE_ALLOW_CONTACT_BY_EMAIL_SUCCEEDED:
      let usersDetails = updateUserDetails(state.usersDetails, action.payload, action.date)
      return { ...state, isUpdating: false, usersDetails : usersDetails }
    case types.UPDATE_ALLOW_CONTACT_BY_EMAIL_FAILED:
      return { ...state, isUpdating: false }
    case types.LOGOUT_SUCCEEDED:
    default:
      return state
  }
}

export default userReducer
